module.exports = __webpack_public_path__ + "static/media/chiesi.839fc41f.png";